"use strict";

exports.__esModule = true;
exports.TYPE_OPTIONS = exports.TOKENS = void 0;
let TYPE_OPTIONS = /*#__PURE__*/function (TYPE_OPTIONS) {
  TYPE_OPTIONS["APPLE"] = "apple";
  TYPE_OPTIONS["FACEBOOK"] = "facebook";
  TYPE_OPTIONS["GOOGLE"] = "google";
  TYPE_OPTIONS["TWITTER"] = "twitter";
  TYPE_OPTIONS["EMAIL"] = "email";
  return TYPE_OPTIONS;
}({});
exports.TYPE_OPTIONS = TYPE_OPTIONS;
let TOKENS = /*#__PURE__*/function (TOKENS) {
  TOKENS["backgroundButton"] = "backgroundButton";
  TOKENS["backgroundButtonHover"] = "backgroundButtonHover";
  TOKENS["backgroundButtonActive"] = "backgroundButtonActive";
  TOKENS["backgroundButtonFocus"] = "backgroundButtonFocus";
  TOKENS["colorTextButton"] = "colorTextButton";
  TOKENS["colorTextButtonHover"] = "colorTextButtonHover";
  TOKENS["colorTextButtonActive"] = "colorTextButtonActive";
  TOKENS["iconColor"] = "iconColor";
  TOKENS["borderColorButtonFocus"] = "borderColorButtonFocus";
  return TOKENS;
}({});
exports.TOKENS = TOKENS;